import { Component } from '@angular/core';
import { membersuiteDebitMemoEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Debit Memos') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuitedebitmemo-form',
    templateUrl: './membersuitedebitmemo.form.component.html'
})
export class membersuiteDebitMemoFormComponent extends BaseFormComponent {
    public record!: membersuiteDebitMemoEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

